import React from "react";
import Slide from "./Slide";

const MobileSecondPart = () => {
  const contents = [
    {
      title: `Your Personal Meal Guide`,
      contents: [
        `Get calorie and protein-focused meal analysis`,
        `based on your logged meals, with personalized`,
        `diet plans recommended by trusted clinical nutritionists.`,
      ],
    },
    {
      title: `Your Health Tracker`,
      contents: [
        `Record your daily symptoms and weight changes`,
        `to monitor your health and receive updated`,
        `meal recommendations based on your condition.`,
      ],
    },
    {
      title: `Your Schedule Manager`,
      contents: [
        `Enter your medication schedules and appointment dates,`,
        `and we'll keep you on track with timely reminders.`,
      ],
    },
  ];

  return (
    <section className="flex flex-col items-center justify-center gap-12 px-[45px] py-12">
      <div className="flex flex-col gap-6 text-center">
        <h3 className="text-2xl font-extrabold">ABOUT HEALIARY</h3>
        <p className="text-center text-base font-medium">
          Healiary was created to be a
          <br />
          <span className="text-main">beacon of light</span> for cancer patients
          <br />
          throughout their challenging treatment journey.
        </p>
      </div>

      <div className="flex w-full flex-col gap-12">
        {contents.map((value, index) => {
          return (
            <div
              className="mx-auto flex h-full flex-col gap-3 "
              key={value.title}
            >
              <img
                src={`/images/mobile/landing/landing_main2-${index + 1}.png`}
                alt={value.title}
              />
              <span className="relative ml-2 w-fit before:absolute before:bottom-0 before:left-0 before:right-0 before:h-1/2 before:bg-[#417FFF24]">
                <span className="relative text-lg font-extrabold">
                  {value.title}
                </span>
              </span>
              <div className="ml-2 text-[13px] font-semibold leading-[20px] text-[#606365]">
                {value.contents.map((p) => (
                  <p key={p}>{p} </p>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default MobileSecondPart;
